import React from 'react';
import PropTypes from 'prop-types';
import withInputErrorMessage from '../withInputErrorMessage';
import SelectBase from './SelectBase';
import withFormikSelect from './withSelectFormik';

const SelectInput = (props) => {
   return (
      <SelectBase
         value={props.value}
         onChange={props.onChange}
         options={props.options}
         isLoading={props.isLoading}
         className={props.className}
         onBlur={props.onBlur}
         name={props.name}
         isDisabled={props.isDisabled}
      />
   );
};

SelectInput.propTypes = {
   options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
   })),
   isLoading: PropTypes.bool,
   onChange: PropTypes.func.isRequired,
   onBlur: PropTypes.func.isRequired,
};

SelectInput.defaultProps = {
   options: [],
   isLoading: false,
};

export default withFormikSelect(withInputErrorMessage(SelectInput));
